import OwnerNavigationRoutes from '@/components/sidebar/OwnerNavigationRoutes'
import OrgAdminNavigationRoutes from '@/components/sidebar/OrgAdminNavigationRoutes'
import TeamManagerNavigationRoutes from '@/components/sidebar/TeamManagerNavigationRoutes'
import SupportAgentNavigationRoutes from '@/components/sidebar/SupportAgentNavigationRoutes'
import AnalystNavigationRoutes from '@/components/sidebar/AnalystNavigationRoutes'
import AnalystViewerOrgNavigationRoutes from '@/components/sidebar/AnalystViewerOrgNavigationRoutes'
import FinanceNavigationRoutes from '@/components/sidebar/FinanceNavigationRoutes'
import DeveloperNavigationRoutes from '@/components/sidebar/DeveloperNavigationRoutes'
import ClientPortalNavigationRoutes from '@/components/sidebar/ClientPortalNavigationRoutes'
import DriverNavigationRoutes from '@/components/sidebar/DriverNavigationRoutes'
import RecruiterNavigationRoutes from '@/components/sidebar/RecruiterNavigationRoutes'
import NavigationRoutes from '@/components/sidebar/NavigationRoutes'
import OperatorNavigationRoutes from '@/components/sidebar/OperatorNavigationRoutes'
import { applySingleSchemaNavFilter } from '@/utils/singleSchemaNavigation'

export type UserRole =
  | 'owner'
  | 'org_admin'
  | 'team_manager'
  | 'support_agent'
  | 'analyst'
  | 'analyst_viewer_org'
  | 'finance'
  | 'developer'
  | 'client_portal'
  | 'driver'
  | 'recruiter'
  | 'admin'
  | 'operator'
  | 'manager'

export function getNavigationRoutes(userRole: UserRole) {
  switch (userRole) {
    case 'owner':
      return applySingleSchemaNavFilter(OwnerNavigationRoutes)
    case 'org_admin':
      return applySingleSchemaNavFilter(OrgAdminNavigationRoutes)
    case 'team_manager':
      return applySingleSchemaNavFilter(TeamManagerNavigationRoutes)
    case 'support_agent':
      return applySingleSchemaNavFilter(SupportAgentNavigationRoutes)
    case 'analyst':
      return applySingleSchemaNavFilter(AnalystNavigationRoutes)
    case 'analyst_viewer_org':
      return applySingleSchemaNavFilter(AnalystViewerOrgNavigationRoutes)
    case 'finance':
      return applySingleSchemaNavFilter(FinanceNavigationRoutes)
    case 'developer':
      return applySingleSchemaNavFilter(DeveloperNavigationRoutes)
    case 'client_portal':
      return ClientPortalNavigationRoutes
    case 'driver':
      return applySingleSchemaNavFilter(DriverNavigationRoutes)
    case 'recruiter':
      return applySingleSchemaNavFilter(RecruiterNavigationRoutes)
    case 'admin':
    case 'manager':
      return applySingleSchemaNavFilter(NavigationRoutes)
    case 'operator':
    default:
      return applySingleSchemaNavFilter(OperatorNavigationRoutes)
  }
}

export function getDefaultRoute(userRole: UserRole): string {
  switch (userRole) {
    case 'owner':
    case 'org_admin':
    case 'manager':
      return 'dashboard-v2'
    case 'team_manager':
      return 'teams'
    case 'support_agent':
      return 'analytics'
    case 'analyst':
      return 'analytics'
    case 'analyst_viewer_org':
      return 'performance'
    case 'finance':
      return 'dashboard-v2'
    case 'developer':
      return 'test-auth'
    case 'client_portal':
      return 'dashboard-v2'
    case 'recruiter':
      return 'recruiter-dashboard'
    case 'driver':
      return 'dashboard-v2'
    case 'admin':
      return 'dashboard-v2'
    case 'operator':
    default:
      return 'performance'
  }
}

export function getRoleDisplayName(userRole: UserRole): string {
  switch (userRole) {
    case 'owner':
      return 'Owner'
    case 'org_admin':
      return 'Organization Admin'
    case 'team_manager':
      return 'Team Manager'
    case 'support_agent':
      return 'Support Agent'
    case 'analyst':
      return 'Analyst/Viewer'
    case 'analyst_viewer_org':
      return 'Analyst Viewer Org'
    case 'finance':
      return 'Finance'
    case 'developer':
      return 'Developer (API)'
    case 'client_portal':
      return 'Client/Partner Portal'
    case 'driver':
      return 'Driver/Rider/Contractor'
    case 'recruiter':
      return 'Recruiter'
    case 'admin':
      return 'Admin'
    case 'manager':
      return 'Manager'
    case 'operator':
    default:
      return 'Operator'
  }
}
